import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { CardContent, Stack, Typography, Box } from "@mui/material";
import utilities from "../../utility/utilities"; // Assuming utilities module is available
import { StyledCard } from "../../assets/styled-components/StyledCard";

function ScheduledUnscheduled({ response }) {
  const woCounts = response?.woPlannedVsUnplannedCounts || {};

  // Scheduled data (sMonthXCount)
  const sData = [
    woCounts?.sMonthSixCount || 0, // Month 6 (past month)
    woCounts?.sMonthFiveCount || 0,
    woCounts?.sMonthFourCount || 0,
    woCounts?.sMonthThreeCount || 0,
    woCounts?.sMonthTwoCount || 0,
    woCounts?.sMonthOneCount || 0, // Month 1 (current month)
  ];

  // Unscheduled data (unsMonthXCount)
  const unsData = [
    woCounts?.unsMonthSixCount || 0, // Month 6 (past month)
    woCounts?.unsMonthFiveCount || 0,
    woCounts?.unsMonthFourCount || 0,
    woCounts?.unsMonthThreeCount || 0,
    woCounts?.unsMonthTwoCount || 0,
    woCounts?.unsMonthOneCount || 0, // Month 1 (current month)
  ];


  const recentMonths = utilities.getRecentSixMonths(); 

  return (
    <StyledCard variant="outlined">
      <CardContent>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography
            mb={1.5}
            variant="h5"
            fontWeight={700}
            color="text.primary"
          >
            W.O Scheduled (PPM) Vs Unscheduled
          </Typography>
        </Stack>
        <Box width="100%">
          <LineChart
            height={350}
            series={[
              { data: sData, label: "Scheduled", color: "#5ECBAD" },
              { data: unsData, label: "Unscheduled", color: "#EF0107" },
            ]}
            xAxis={[
              {
                scaleType: "point",
                data: recentMonths.map((month) => month.label),
              },
            ]}
            slotProps={{
              legend: {
                direction: "row",
                position: {
                  vertical: "bottom",
                  horizontal: "center",
                },
                padding: 0,
                itemMarkWidth: 15,
                itemMarkHeight: 15,
                markGap: 5,
                itemGap: 16,
                labelStyle: {
                  fontSize: 12,
                  color: "text.primary", 
                  fontWeight: 400,
                },
              },
            }}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
}

export default ScheduledUnscheduled;
